import { render, staticRenderFns } from "./ModalTermParts.vue?vue&type=template&id=9682d7fa&"
import script from "./ModalTermParts.vue?vue&type=script&lang=js&"
export * from "./ModalTermParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports